import {FC, Card, PropsWithChildren, useSearchParams, useEffect} from 'external/react'

import ButtonBack from 'components/ButtonBack'

import usePackage from 'context/package-context/hook'
import BasicLayout from './BasicLayout'
import SubscriptionAction from 'pages/home/payment/SubscriptionAction'
import { notifySuccess, notifyWarning, showConfirmCancelSubscription } from 'components/Notify'
import { paymentService } from 'services/payment.service'

const PackageContainer: FC<PropsWithChildren> = props => {

    const {children} = props

    const [params, setSearchParams] = useSearchParams()
	  const {state: {packageItem}, update} = usePackage()
    const id = packageItem.data?.id
    const offerName = packageItem.data?.offerName
    const plan_alias = packageItem.data?.plan_alias
    const paymentMode = packageItem.data?.paymentMode
    const subscriptionStatus = packageItem.data?.subscriptionStatus || 'canceled'
    
    async function handleItemAction(index, status){
       const subscription = packageItem.data
       if (!subscription) return
       switch (status) {
          case 'active':
            console.log(subscription)
            const {isConfirmed: cancelationConfirmed} = await showConfirmCancelSubscription(subscription.subscriptionEnds || new Date())
            if (cancelationConfirmed) {
              const response = await paymentService.cancelSubscription(subscription);
			        notifyWarning(`Tu suscripción: Plan ${subscription.offerName} ha sido cancelada.`)
              update({packageRefreshes: {'$apply': i => i + 1}})
            }
            break;
          case 'pending': 
            await paymentService.reactiveSubscription(subscription);
            notifySuccess(`Tu suscripción Plan ${subscription.offerName} ha sido reactivada.`);
            update({packageRefreshes: {'$apply': i => i + 1}})
            break;
          case 'canceled':
            const {data: reactivateSession} = await paymentService.activateCanceledSubscription({...subscription, source: `/home/packages/${id}`});
            if (reactivateSession.success) {
              location.replace(reactivateSession.data.url)
            }
            break;
          default:
            console.log(`unhandled: ${subscription}`)
            break;
       }
    }

    useEffect(() => {
      const subscription = packageItem.data
      if (!subscription) return
      if (params.has('reactivated')) {
        const newParams = new URLSearchParams(params)
        newParams.delete('reactivated')
        notifySuccess(`Tu suscripción Plan ${subscription.offerName} ha sido reactivada.`);
        setSearchParams(newParams)
      }
    }, [params, packageItem])

    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex package-detail'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path='/home/packages' />
                </div>
                <div className='tex-capitalize ms-2' style={{ fontSize: '31px' }}>
                    <span className='text-capitalize fw-bold'>Plan {offerName}<span className='fn-s-14 ml-1'>({plan_alias})</span></span>
                </div>
                <div className='flex-grow-1' />
                {paymentMode === 'subscription' && <SubscriptionAction index={-1} onClick={handleItemAction} status={subscriptionStatus} disabled={false} label={subscriptionStatus == 'canceled' ? 'Reactivar' : undefined}/>}
            </Card.Header>
            {children}
        </BasicLayout>
    )
}

export {PackageContainer as default}